<template>
    <div>
        <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
        <bc-dialog :value="quality_control_dialog" max-width="1200">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        currObjField("qc_id")
                            ? currQcField("has_pack_list") == "1"
                                ? $t("lang.view_quality_control")
                                : $t("lang.edit_quality_control")
                            : current_obj
                            ? $t("lang.add_quality_control")
                            : $t("lang.select_batch")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeQualityControlDialog"
                        :dialog-status="quality_control_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text :class="{ 'pa-0': !current_obj }">
                    <v-form ref="quality_control">
                        <v-container grid-list-form :class="{ 'prevent-click': currQcField('has_pack_list') == '1' }">
                            <v-layout row wrap>
                                <v-flex xs12 sm4 pa-0 align-self-start>
                                    <v-layout row wrap px-3 py-0 inner-layout>
                                        <v-flex xs6 mt-1>{{ `${$t("lang.batch_control_id")}:` }}</v-flex
                                        ><v-flex xs6 fw-bold mt-1>{{ currObjField("batch_control_id") || "---" }}</v-flex>
                                        <v-flex xs6 mt-1>{{ `${$t("lang.company")}:` }}</v-flex
                                        ><v-flex xs6 fw-bold mt-1>{{ currObjField("company") || "---" }}</v-flex>
                                        <v-flex xs6 mt-1>{{ `${$t("lang.part_number")}:` }}</v-flex
                                        ><v-flex xs6 fw-bold mt-1>{{ currObjField("customer_part_number") || "---" }}</v-flex>
                                        <v-flex xs6 mt-1>{{ `${$t("lang.part_name")}:` }}</v-flex
                                        ><v-flex xs6 fw-bold mt-1>{{ currObjField("name") || "---" }}</v-flex>
                                        <v-flex xs6 mt-1>{{ `${$t("lang.qty")}:` }}</v-flex
                                        ><v-flex xs6 fw-bold mt-1>{{ currObjField("batch_size") || "---" }}</v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm4 offset-sm1 pa-0 align-self-start>
                                    <v-layout
                                        row
                                        wrap
                                        px-3
                                        py-0
                                        inner-layout
                                        v-if="
                                            currObjField('qc_id')
                                                ? currObjField('work_orders_stations') || currQcField('work_orders_stations')
                                                : currObjField('work_orders_stations')
                                        "
                                    >
                                        <template
                                            v-for="(station, index) in currObjField('qc_id')
                                                ? currObjField('work_orders_stations') || currQcField('work_orders_stations')
                                                : currObjField('work_orders_stations')"
                                        >
                                            <v-flex xs6 mt-1 :key="index">{{ station.station }}:</v-flex
                                            ><v-flex xs2 fw-bold mt-1 :key="`station_${index}`">{{ station.short_code }}</v-flex
                                            ><v-flex xs4 fw-bold mt-1 :key="`pattern_${index}`">{{ station.pattern_number }}</v-flex>
                                        </template>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm3 align-self-start px-0>
                                    <v-layout row v-if="!currObjField('qc_id')">
                                        <v-flex order-xs2 order-sm1 :class="$bp.xsOnly ? 'text-left' : 'text-right'">
                                            <span class="headline">{{ currUserField("combined_name") }}</span>
                                            <span class="fs-14">{{ `Creating: ${time_when_adding}` }}</span>
                                        </v-flex>
                                        <v-flex shrink mx-2 order-xs1 order-sm2 style="width: 50px">
                                            <v-avatar v-if="current_user">
                                                <img :src="currUserField('photo_thumb')" />
                                            </v-avatar>
                                        </v-flex>
                                    </v-layout>
                                    <template v-else>
                                        <v-layout row inner-layout>
                                            <v-flex order-xs2 order-sm1 :class="$bp.xsOnly ? 'text-left' : 'text-right'">
                                                <span class="headline">{{ currQcField("created_by") }}</span>
                                                <span class="fs-14">{{ `Created: ${currQcField("date_created")}` }}</span>
                                            </v-flex>
                                            <v-flex shrink mx-2 order-xs1 order-sm2 style="width: 50px">
                                                <v-avatar v-if="currQcField('created_by_photo')">
                                                    <img :src="currQcField('created_by_photo')" />
                                                </v-avatar>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row inner-layout v-if="currQcField('date_modified')" pt-3>
                                            <v-flex order-xs2 order-sm1 :class="$bp.xsOnly ? 'text-left' : 'text-right'">
                                                <span class="headline">{{ currQcField("last_updated_by") }}</span>
                                                <span class="fs-14">{{ `Updated: ${currQcField("date_modified")}` }}</span>
                                            </v-flex>
                                            <v-flex shrink mx-2 order-xs1 order-sm2 style="width: 50px">
                                                <v-avatar v-if="currQcField('last_updated_by_photo')">
                                                    <img :src="currQcField('last_updated_by_photo')" />
                                                </v-avatar>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-flex>
                                <v-flex xs12 sm4 :class="{ 'mt-2': $bp.smAndUp }">
                                    <bc-date-picker
                                        v-model="edit_quality_control.inspection_date"
                                        :label="$t('lang.inspection_date')"
                                        :rules="ifValid('quality_control.inspection_date')"
                                        :disabled="currQcField('has_pack_list') == '1'"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs12 sm4 :class="{ 'mt-2': $bp.smAndUp }">
                                    <bc-select
                                        v-model="edit_quality_control.test_summary"
                                        :label="`${$t('lang.test_summary')} *`"
                                        :items="pass_fail_hold"
                                        item-value="value"
                                        item-text="text"
                                        :rules="ifValid('quality_control.test_summary')"
                                        :readonly="currQcField('has_pack_list') == '1'"
                                    ></bc-select>
                                </v-flex>
                                <v-flex xs12 sm4 :class="{ 'mt-2': $bp.smAndUp }">
                                    <bc-select
                                        v-model="edit_quality_control.microstructure"
                                        :label="$t('lang.microstructure')"
                                        :items="pass_fail"
                                        item-value="value"
                                        item-text="text"
                                        :clearable="!currQcField('test_summary') || currQcField('has_pack_list') == '0'"
                                        @click:clear="
                                            $nextTick(() => {
                                                edit_quality_control.microstructure = null;
                                            })
                                        "
                                        :rules="ifValid('quality_control.microstructure')"
                                    ></bc-select>
                                </v-flex>
                                <v-flex xs12 d-inline-flex v-if="!currQcField('test_summary')">
                                    <h5 class="my-auto" style="flex-grow: 0 !important">Change Spec Type</h5>
                                    <bc-select
                                        v-model="edit_quality_control.spec_type_id"
                                        :label="$t('lang.spec_type_id')"
                                        :items="spec_types"
                                        item-value="spec_type_id"
                                        item-text="spec_type"
                                        hide-details
                                        single-line
                                        class="ml-3 pt-0"
                                        style="max-width: 250px"
                                        @change="getSpecByType($event)"
                                        :readonly="currQcField('has_pack_list') == '1'"
                                    ></bc-select>
                                </v-flex>
                                <v-flex
                                    xs12
                                    px-0
                                    v-if="
                                        currObjField('qc_id')
                                            ? current_qc && (current_qc.quality_control_details || []).length > 0
                                            : current_obj && (current_obj.spec_types || []).length > 0
                                    "
                                >
                                    <v-data-table
                                        :headers="spec_headers"
                                        :items="currObjField('qc_id') ? current_qc.quality_control_details : current_obj.spec_types"
                                        :no-data-text="$t('lang.no_data_available')"
                                        hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr :style="{ backgroundColor: error_class(test_result[props.index], props.item) }">
                                                <td>{{ props.item.item }}</td>
                                                <td>{{ props.item.location }}</td>
                                                <td class="text-center">{{ props.item.unit }}</td>
                                                <td class="text-center">{{ props.item.ll }}</td>
                                                <td class="text-center">{{ props.item.control_ll }}</td>
                                                <td class="px-2">
                                                    <v-text-field
                                                        v-if="currQcField('has_pack_list') != '1'"
                                                        v-model="test_result[props.index]"
                                                        :rules="ifValid([...$r.required(true), ...$r.numeric(2)])"
                                                        type="number"
                                                    ></v-text-field>
                                                    <span v-else>{{ props.item.test_result }}</span>
                                                </td>
                                                <td class="text-center">{{ props.item.control_ul }}</td>
                                                <td class="text-center">{{ props.item.ul }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                                <v-flex xs12 v-if="current_obj && edit_quality_control.test_summary == '0' && checkError('fail')">
                                    <v-textarea
                                        v-model="edit_quality_control.reason"
                                        :label="$t('lang.reason')"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('quality_control.reason')"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                        v-model="edit_quality_control.notes"
                                        :label="$t('lang.notes')"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('quality_control.notes')"
                                        :readonly="currQcField('has_pack_list') == '1'"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                    <!-- <v-data-table
                        v-else
                        :headers="batches_headers"
                        :items="available_batches || []"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :must-sort="true"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="selectBatch(props.item)">
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.customer_part_number }}</td>
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.batch_control_id }}</td>
                                <td>{{ props.item.batch_size }}</td>
                            </tr>
                        </template>
                    </v-data-table> -->
                </v-card-text>
                <v-card-actions v-if="location == 'list' && hasPerm('batch.read') && $bp.smallScreen">
                    <v-btn v-if="$bp.smallScreen && current_obj != null && location == 'list' && back_to_scan" color="secondary" @mouseup.left="backToBatch()">
                        <v-icon class="mr-1">keyboard_return</v-icon>
                        {{ $t("lang.back") }}
                    </v-btn>
                    <v-menu :nudge-width="50" offset-y v-if="$bp.smallScreen && hasPerm('batch.read') && currQcField('test_summary')">
                        <v-btn
                            slot="activator"
                            color="primary"
                            :class="{ 'ml-2': $bp.smallScreen && current_obj != null && location == 'list' && back_to_scan }"
                        >
                            {{ "Print" }}
                            <v-icon>expand_more</v-icon>
                        </v-btn>

                        <v-list>
                            <v-list-tile v-for="(item, index) in printOptions" :key="index" @click="dev_mode ? showPrinter(item.type) : printLabel(item.type)">
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-card-actions>
                <v-card-actions :class="{ 'mt-0': location == 'list' && hasPerm('batch.read') && $bp.smallScreen }">
                    <v-btn
                        v-if="hasPerm('qc_inspection.delete') && currObjField('qc_id') && currQcField('has_pack_list') != '1'"
                        color="error"
                        @mouseup.left="$refs.delete_quality_control.openDialog()"
                        >{{ $t("lang.delete") }}</v-btn
                    >
                    <v-btn v-if="!$bp.smallScreen && current_obj != null && location == 'list' && back_to_scan" color="secondary" @mouseup.left="backToBatch()">
                        <v-icon class="mr-1">keyboard_return</v-icon>
                        {{ $t("lang.back") }}
                    </v-btn>
                    <v-btn
                        v-if="location == 'list' && hasPerm('batch.read')"
                        color="primary"
                        @mouseup.left="
                            $router.push({
                                name: 'batch_profile',
                                params: { work_order_id: currObjField('work_order_id'), batch_id: currObjField('batch_id') },
                            })
                        "
                    >
                        {{ "View Batch" }}
                    </v-btn>
                    <bc-btn-nonconformance
                        ref="nonconformance"
                        entity_object="work_orders_batch"
                        :entity_id="currObjField('batch_id')"
                        type="button"
                    ></bc-btn-nonconformance>
                    <v-menu :nudge-width="50" offset-y v-if="!$bp.smallScreen && hasPerm('batch.read') && currQcField('test_summary')">
                        <v-btn slot="activator" color="primary" class="ml-2">
                            {{ "Print" }}
                            <v-icon>expand_more</v-icon>
                        </v-btn>

                        <v-list>
                            <v-list-tile v-for="(item, index) in printOptions" :key="index" @click="dev_mode ? showPrinter(item.type) : printLabel(item.type)">
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeQualityControlDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        v-if="hasPerm('qc_inspection.update') && (!currQcField('test_summary') || currQcField('has_pack_list') == '0')"
                        color="success"
                        @mouseup.left="modifyQualityControl(currObjField('qc_id') ? 'patch' : 'post', currObjField('qc_id'))"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_quality_control"
            :heading="$t('lang.delete_quality_control')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyQualityControl('delete', currObjField('qc_id'))"
        ></delete-confirmation-dialog>
        <bc-dialog :value="save_error_dialog">
            <v-card>
                <v-card-title class="red-dialog-title">
                    <span class="headline">{{ $t("lang.error_saving") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="save_error_dialog"
                        :dialog-status="save_error_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12
                                >Currently a result is outside the lower/upper limit but "Pass" was the selected test summary. Verify the test results have been
                                entered properly.</v-flex
                            >
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @mouseup.left="save_error_dialog = false">{{ $t("lang.ok") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        location: {
            type: String,
            default: "list",
        },
        stateProperty: {
            type: String,
            default: "quality_control",
        },
    },
    data() {
        return {
            time_when_adding: null,
            file_name: null,
            back_to_scan: false,
            current_obj: null,
            save_error_dialog: false,
            quality_control_dialog: false,
            pass_fail_hold: [
                { text: this.$t("lang.hold"), value: "2" },
                { text: this.$t("lang.pass"), value: "1" },
                { text: this.$t("lang.fail"), value: "0" },
            ],
            pass_fail: [
                { text: this.$t("lang.pass"), value: "1" },
                { text: this.$t("lang.fail"), value: "0" },
            ],
            printOptions: [
                { title: "Print Report", type: "print" },
                { title: "Print Tag", type: "print_qc_tag" },
            ],
            edit_quality_control: {
                batch_id: "",
                test_summary: "",
                inspection_date: "",
                notes: "",
                microstructure: "",
                spec_type_id: "1",
                reason: "",
            },
            test_result: [],
            spec_types: null,
            spec_headers: [
                { text: this.$t("lang.item"), sortable: false, width: "20%" },
                { text: this.$t("lang.location"), sortable: false, width: "20%" },
                { text: this.$t("lang.unit"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.lower_limit"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.control_ll_short"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.result"), sortable: false, width: "10%" },
                { text: this.$t("lang.control_ul_short"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.upper_limit"), sortable: false, width: "10%", align: "center" },
            ],
            batches_headers: [
                { text: this.$t("lang.customer"), value: "company", width: "20%" },
                { text: this.$t("lang.part_number"), value: "customer_part_number", width: "20%" },
                { text: this.$t("lang.part_name"), value: "name", width: "20%" },
                { text: this.$t("lang.dta_control"), value: "batch_control_id", width: "20%" },
                { text: this.$t("lang.batch_size"), value: "batch_size", width: "20%" },
            ],
        };
    },
    computed: {
        ...mapState({
            rules_quality_control: (state) => state.validation.rules_quality_control,
            available_batches: (state) => state.quality_control.available_batches,
            current_qc: (state) => state.quality_control.current_qc,
            quality_control: (state) => state.quality_control.quality_control,
        }),
        error_class() {
            return (value, item) => {
                if (value && value != "" && value != null) {
                    if ((item.ll && +value < +item.ll) || (item.ul && +value > +item.ul)) {
                        return "rgba(255, 0, 0, .3) !important";
                    } else if (+value < +item.control_ll || +value > +item.control_ul) {
                        return "background-color: rgba(238, 255, 0, 0.3) !important";
                    }
                }
                return "";
            };
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currQcField() {
            return (field) => {
                return this.current_qc && field && this.current_qc[field] ? this.current_qc[field] : "";
            };
        },
    },
    methods: {
        getQualityControl(refresh = true) {
            this.startLoader();
            this.$store
                .dispatch("fetchQualityControl", {
                    url: "quality_control",
                    method: "get",
                    stateProperty: "quality_control",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(refresh);
                });
        },
        getSpecByType(spec_type) {
            if (this.current_obj && this.current_obj.part_id) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchQualityControl", {
                        url: `parts/${this.current_obj.part_id}/spec`,
                        method: "get",
                        stateProperty: "current_qc.quality_control_details",
                        dataProperty: "parts_spec",
                        commit: !!this.currObjField("qc_id"),
                        body: {
                            spec_type_id: spec_type,
                        },
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.parts_spec) {
                            this.test_result = Array((data.parts_spec || []).length).fill("");
                            this.current_obj.spec_types = data.parts_spec;
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        closeQualityControlDialog() {
            this.quality_control_dialog = false;
            this.$refs.delete_quality_control.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            this.test_result = Array((this.test_result || []).length).fill("");
        },
        checkError(check) {
            let result = false;
            let test_array = !this.currObjField("qc_id") ? this.currObjField("spec_types") : this.currQcField("quality_control_details");
            if (test_array && this.edit_quality_control.test_summary == "1" && check == "pass") {
                let error_array = [];
                (test_array || []).forEach((t, i) => {
                    error_array.push(this.error_class(this.test_result[i], t));
                });
                result = error_array.includes("result-error");
            } else if (test_array && this.edit_quality_control.test_summary == "0" && check == "fail") {
                let error_array = [];
                let abort = false;
                (test_array || []).forEach((t, i) => {
                    if (this.test_result[i] == "" || this.test_result[i] == null) {
                        abort = true;
                    }
                    error_array.push(this.error_class(this.test_result[i], t));
                });
                result = abort ? false : !error_array.includes("result-error");
            }
            return result;
        },
        showQualityControl(item = null) {
            this.quality_control_dialog = true;
            this.current_obj = item;
            this.edit_quality_control.spec_type_id = item ? item.spec_type_id : "1";
            if (item && item.qc_id) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchQualityControl", {
                        url: `quality_control/${item.qc_id}`,
                        method: "get",
                        stateProperty: "current_qc",
                        dataProperty: "quality_control",
                        commit: true,
                    })
                    .then((data) => {
                        this.$store.commit("toggleModalLoader", false);
                        if (data.spec_types) {
                            this.spec_types = data.spec_types;
                        }
                        if (data.quality_control && (data.quality_control.quality_control_details || []).length > 0) {
                            this.test_result = data.quality_control.quality_control_details.map((x) => x.test_result);
                        }

                        this.$nextTick(() => {
                            this.assignObj(this.edit_quality_control, this.current_qc, this.rules_quality_control);
                        });
                    });
            } else {
                this.$store.commit("commitQualityControl", { property: "current_qc", with: null });
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchQualityControl", {
                        url: `quality_control/available_batches`,
                        method: "get",
                        stateProperty: "available_batches",
                        commit: true,
                    })
                    .then((data) => {
                        this.$store.commit("toggleModalLoader", false);
                    });

                this.$nextTick(() => {
                    this.assignObj(this.edit_quality_control, this.current_qc, this.rules_quality_control);
                });
            }
            if (this.$refs.quality_control) item ? this.$refs.quality_control.resetValidation() : this.$refs.quality_control.reset();
        },
        modifyQualityControl(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("quality_control")) {
                        if (method != "delete" && this.checkError("pass")) {
                            this.save_error_dialog = true;
                            return;
                        } else {
                            if (this.edit_quality_control.test_summary != "0") {
                                this.edit_quality_control.reason = "";
                            }
                        }
                        this.$store.commit("toggleModalLoader", true);
                        if (method != "delete" && this.current_obj && (this.test_result || []).length > 0) {
                            let spec_results = [];
                            let details_array = this.currObjField("qc_id") ? this.current_qc.quality_control_details : this.current_obj.spec_types;
                            details_array.forEach((d, i) => {
                                spec_results.push({
                                    spec_id: d.spec_id,
                                    test_result: this.test_result[i],
                                });
                            });
                            this.edit_quality_control.quality_control_details = spec_results;
                        }
                        this.$store
                            .dispatch("fetchQualityControl", {
                                pk: "batch_id",
                                id: this.currObjField("batch_id"),
                                url: `quality_control/${id ? id : ""}`,
                                method: method,
                                stateProperty: this.stateProperty,
                                dataProperty: method == "delete" ? "batch" : "quality_control",
                                commit: this.location == "list" ? true : false,
                                body: this.edit_quality_control,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    if (this.location == "batch_profile") {
                                        this.$store.commit("mutateWorkOrder", {
                                            property: "work_orders_batch",
                                            method: "patch",
                                            with: {
                                                has_quality_control: method == "delete" ? "0" : "1",
                                                qc_id: method == "delete" ? null : data.quality_control.qc_id,
                                            },
                                        });
                                    }

                                    // dashboard only pulling pending/on hold, delete if failed/passed
                                    if (
                                        this.stateProperty == "dashboard_quality_control" &&
                                        (data.quality_control.qc_summary == "0" || data.quality_control.qc_summary == "1")
                                    ) {
                                        this.$store.commit("mutateQualityControl", {
                                            property: this.stateProperty,
                                            pk: "qc_id",
                                            id: data.quality_control.qc_id,
                                            method: "delete",
                                        });
                                    }

                                    this.closeQualityControlDialog();
                                    this.getQualityControl(false);
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        selectBatch(item = null, from_scan = false) {
            if (!from_scan) this.quality_control_dialog = true;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchQualityControl", {
                    url: `quality_control/batch/${item.batch_id}`,
                    method: "get",
                    stateProperty: "current_qc",
                    dataProperty: "batch.quality_control",
                    commit: true,
                })
                .then((data) => {
                    this.assignObj(this.edit_quality_control, this.current_qc, this.rules_quality_control);
                    this.time_when_adding =
                        new Date().toLocaleString("fr-CA", {
                            timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        }) +
                        " " +
                        new Date().toLocaleTimeString("en-US", {
                            timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                            hour12: false,
                            hour: "numeric",
                            minute: "numeric",
                        });
                    if (data.batch) {
                        this.current_obj = data.batch;
                        this.edit_quality_control.spec_type_id = data.batch.spec_type_id;
                        this.edit_quality_control.batch_id = data.batch.batch_id;
                        this.edit_quality_control.inspection_date = this.current_day;
                        if (data.spec_types) {
                            this.spec_types = data.spec_types;
                        }
                        if ((data.batch.spec_types || []).length > 0) {
                            this.test_result = Array((data.batch.spec_types || []).length).fill("");
                        }
                        if (data.batch.quality_control && data.batch.quality_control.quality_control_details) {
                            this.test_result = data.batch.quality_control.quality_control_details.map((x) => x.test_result);
                        }
                        if (from_scan) {
                            this.quality_control_dialog = true;
                            this.$emit("scan-close");
                        }
                        this.back_to_scan = from_scan;
                    } else {
                        this.quality_control_dialog = false;
                        this.current_obj = null;
                        if (from_scan) this.$emit("scan-error");
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        backToBatch() {
            this.current_obj = null;
            this.$store.commit("commitQualityControl", { property: "current_qc", with: null });
            if (this.back_to_scan) {
                this.quality_control_dialog = false;
                this.$emit("scan-open");
            }
        },
        showPrinter(type) {
            // this.startLoader();
            if (this.currQcField("qc_id")) {
                this.$refs.print.openDialog();

                this.$store
                    .dispatch("fetchQualityControl", {
                        url: `quality_control/${this.currQcField("qc_id")}/${type}`,
                        method: "get",
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.qc_report) {
                            this.file_name = data.qc_report.file_name;
                        } else if (typeof data != "undefined" && data.qc_tags) {
                            this.file_name = data.qc_tags.file_name;
                        } else {
                            this.file_name = "";
                            this.$refs.print.close();
                            this.createAlert();
                        }
                    });
            }
        },
        printLabel(type) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchQualityControl", {
                    url: `quality_control/${this.currQcField("qc_id")}/${type}`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.qc_report) {
                        this.file_name = data.qc_report.file_name;
                    } else if (typeof data != "undefined" && data.qc_tags) {
                        this.file_name = data.qc_tags.file_name;
                    } else {
                        this.file_name = "";
                        this.createAlert();
                    }
                    if (this.file_name != "") {
                        this.$refs.print.printReport(this.file_name);
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
    },
};
</script>
